<template>
  <v-form
    ref="emailForm"
    @submit.prevent="changeEmailSubmit"
    :errorMessages="errors.detail"
    lazy-validation
    class="fill-height"
  >
    <v-card flat class="fill-height d-flex flex-column">
      <v-card-title>Change Email</v-card-title>
      <v-card-text>
        <v-alert dense outlined type="success" v-if="emailChanged">
          Email changed successfuly.
        </v-alert>
        <v-alert dense outlined type="error" v-if="errors.token">
          <ul>
            <li v-for="error in errors.token" :key="error">{{ error }}</li>
          </ul>
        </v-alert>
        <v-text-field
          v-model="email"
          label="New Email"
          outlined
          dense
          :rules="rules.emailRules"
          :errorMessages="errors.newUsername"
        ></v-text-field>
        <v-text-field
          v-model="currentPassword"
          label="Current Password"
          type="password"
          outlined
          dense
          :rules="rules.PasswordRules"
          :errorMessages="errors.currentPassword"
        ></v-text-field>
      </v-card-text>
      <v-spacer></v-spacer>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn type="submit" color="primary" text :disabled="submitted">
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import {mapActions} from 'vuex'
import {changeEmail} from '@/services/api/auth'
import {fieldRequired, validEmail} from '@/form-rules'

export default {
  name: "PasswordChangeForm",
  data() {
    return {
      currentPassword: "",
      email: "",
      errors: {},
      submitted: false,
      emailChanged: false,
      currentPasswordRules: [fieldRequired()],
      rules: {
        email: [fieldRequired(), validEmail()],
        password: [fieldRequired()]
      }
    };
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    changeEmailSubmit() {
      this.submitted = true;
      changeEmail(this.currentPassword, this.email)
        .then(() => {
          this.logout()
          .then(() => {
            this.$router.push("/login?emailChanged=true")
          })
        })
        .catch((error) => {
          this.errors = error.response.data;
          this.submitted = false;
        });
    },
  },
};
</script>

<style></style>
